import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="bg-navy-dark py-8 md:py-24 px-4" data-id="element-129">
      <div className="max-w-3xl mx-auto" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-131">
          <h2 className="text-2xl md:text-5xl font-black text-white mb-4 md:mb-10 text-center" data-id="element-132">
            Ahora imaginá esto
          </h2>

          <p className="text-base md:text-xl text-gray-300 mb-4 md:mb-8 text-center" data-id="element-133">
            Abrís tu estudio y…
          </p>

          <div className="bg-navy-light p-5 md:p-8 rounded-xl md:rounded-2xl border border-green-500/30 shadow-[0_0_30px_rgba(34,197,94,0.1)]" data-id="element-134">
            <ul className="space-y-3 md:space-y-6 text-base md:text-xl" data-id="element-135">
              <li className="flex items-center gap-3" data-id="element-136">
                <span className="bg-green-500/20 text-green-400 p-1.5 md:p-2 rounded-full text-sm" data-id="element-137">
                  ✅
                </span>
                <span className="text-white font-medium" data-id="element-138">
                  Sabés exactamente qué hacer
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-139">
                <span className="bg-green-500/20 text-green-400 p-1.5 md:p-2 rounded-full text-sm" data-id="element-140">
                  ✅
                </span>
                <span className="text-white font-medium" data-id="element-141">
                  Cada cliente está registrado
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-142">
                <span className="bg-green-500/20 text-green-400 p-1.5 md:p-2 rounded-full text-sm" data-id="element-143">
                  ✅
                </span>
                <span className="text-white font-medium" data-id="element-144">
                  Cada caso tiene seguimiento
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-145">
                <span className="bg-green-500/20 text-green-400 p-1.5 md:p-2 rounded-full text-sm" data-id="element-146">
                  ✅
                </span>
                <span className="text-white font-medium" data-id="element-147">
                  Todo está organizado
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-148">
                <span className="bg-green-500/20 text-green-400 p-1.5 md:p-2 rounded-full text-sm" data-id="element-149">
                  ✅
                </span>
                <span className="text-white font-medium" data-id="element-150">
                  No dependés de tu memoria
                </span>
              </li>
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}